import unitRestService from "@/services/unitApi";
import store from "@/store/store";

export default ({
    state: {
        unit: undefined,
        number: "",
        description: "",
        secret: "",
        guestSecret: "",
        supportsGuests: false,
        contactName: "",
        phoneNumber: "",
        email: "",
        portalUrl: ""
    },

    mutations: {
        SET_UNIT(state, value) {
            if(value) {
                state.unit = value
            } else {
                state.unit = undefined
            }
        },
        SET_UNIT_NUMBER(state, value) {
            state.number = value;
        },
        SET_DESCRIPTION(state, value) {
            state.description = value;
        },
        SET_SECRET(state, value) {
            state.secret = value;
        },
        SET_GUEST_SECRET(state, value) {
            state.guestSecret = value;
        },
        SET_SUPPORTS_GUEST_SECRET(state, value) {
            state.supportsGuests = value;
        },
        SET_CONTACTNAME(state, value) {
            state.contactName = value;
        },
        SET_PHONE_NUMBER(state, value) {
            state.phoneNumber = value;
        },
        SET_EMAIL(state, value) {
            state.email = value;
        },
        SET_PORTAL_URL(state, value) {
            state.portalUrl = value;
        }
    },
    actions: {
        async loadUnitInformationFromApi({commit}) {
            if(!store.getters.getIsLoggedIn) {
                return
            }
            await unitRestService.getUnit().then(result => {
                commit('SET_UNIT', result)
                commit('SET_UNIT_NUMBER', result.number)
                commit('SET_DESCRIPTION', result.description || "")
                commit('SET_SECRET', result.secret)
                commit('SET_GUEST_SECRET', result.guestSecret)
                commit('SET_SUPPORTS_GUEST_SECRET',  Boolean(result.guestSecret))
                commit('SET_CONTACTNAME', result.contact.contactName)
                commit('SET_PHONE_NUMBER', result.contact.phoneNumber)
                commit('SET_EMAIL', result.contact.email)
                console.log("About to try _links: ", result._links)
                if(result._links && result._links.tenantPortal){
                    let urlLinkItem = result._links.tenantPortal;
                    console.log("url link item has been grabbed ", urlLinkItem)
                    commit('SET_PORTAL_URL', urlLinkItem.href)
                }
            }, error => {
                console.error(error);
            });
        }
    },
    getters: {
        getUnit(state) {
            return state.unit
        },
        getUnitNumber(state){ return state.number;},
        getUnitDescription(state){ return state.description;},
        getUnitSecret(state){ return state.secret;},
        getUnitGuestSecret(state){ return state.guestSecret;},
        getUnitSupportsGuests(state){ return state.supportsGuests;},
        getUnitContactName(state){ return state.contactName;},
        getUnitContactPhone(state){ return state.phoneNumber;},
        getUnitContactEmail(state){ return state.email;},
        getUnitTenantPortalUrl(state){ return state.portalUrl;},
    }
})
